import { useParams } from "react-router-dom";

export function useLang() {
  const params = useParams();
  return {
    lang: params.lang ?? "en",
  };
}
